import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Card } from "primereact/card";
import { Button } from "primereact/button";
import {
  GetStatus,
  ActiveStatus,
  InactiveStatus,
} from "../../../store/status-store/status-actions";
import Loading from "../../../components/UI/Loading";
import { getTokenInfo } from "../../../utils/Guard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const StatusDetail = () => {
  const param = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const status = useSelector((state) => state.status.status);
  const notification = useSelector((state) => state.ui.notification);
  const userInfo = getTokenInfo();

  const statusData = [
    { label: "Nombre", value: status.name },
    { label: "Descripción", value: status.description },
    { label: "Color", value: status.color },
  ];

  useEffect(() => {
    if (status.id === undefined || status.id === 0) {
      dispatch(GetStatus(param.statusId, userInfo.Email));
    }
  }, [param.statusId, dispatch, status.id, userInfo.Email]);

  const activeHandler = () => {
    dispatch(ActiveStatus(param.statusId, userInfo.Email));
  };
  const inactiveHandler = () => {
    dispatch(InactiveStatus(param.statusId, userInfo.Email));
  };
  let activeSuspend;
  if (
    userInfo.Roles !== undefined &&
    userInfo.Roles.includes("status.active")
  ) {
    activeSuspend = (
      <div className="field col-12 md:col-3 mt-3">
        <Button
          rounded
          text
          raised
          style={{ backgroundColor: "#fff", width: "150px" }}
          label="Activar"
          className="p-button-success"
          onClick={activeHandler}
          icon={
            notification && notification.status === "pending"
              ? "pi pi-spin pi-spinner"
              : "pi pi-check"
          }
          disabled={notification && notification.status === "pending"}
        />
      </div>
    );
  }
  if (status.status) {
    if (
      userInfo.Roles !== undefined &&
      userInfo.Roles.includes("status.inactive")
    ) {
      activeSuspend = (
        <div className="field col-12 md:col-3 mt-3">
          <Button
            rounded
            text
            raised
            style={{ backgroundColor: "#fff", width: "150px" }}
            label="Suspender"
            className="p-button-warning"
            onClick={inactiveHandler}
            icon={
              notification && notification.status === "pending"
                ? "pi pi-spin pi-spinner"
                : "pi pi-times"
            }
            disabled={notification && notification.status === "pending"}
          />
        </div>
      );
    }
  }

  return (
    <>
      <div
        style={{ backgroundColor: "#133047", padding: "1%", height: "100vh" }}
      >
        {(status.id === undefined || status.id <= 0) && (
          <>
            <Loading />
          </>
        )}
        {(status.id !== undefined || status.id > 0) && (
          <Card
            style={{
              backgroundColor: "#F9FAFB",
              marginLeft: "0%",
              boxShadow: "none",
              width: "100%",
              height: "auto",
            }}
          >
            <div
              className="user-info text-center"
              style={{ borderBottom: "solid #fff", paddingBottom: "1.3%" }}
            >
              <h2 id="header" className="mb-2" style={{ color: "" }}>
                {status.name}
              </h2>
              <span
                className="badge bg-label-secondary"
                style={{
                  fontSize: "large",
                  color: "#D34330",
                  fontWeight: "bold",
                }}
              >
                Estado
              </span>
            </div>
            <div className="formgrid grid mt-3">
              <div className="field col-12 md:col-12">
                <>
                  <DataTable
                    value={statusData}
                    style={{ width: "100%", padding: "1%" }}
                  >
                    <Column
                      field="label"
                      style={{
                        width: "50%",
                        textAlign: "right",
                        fontWeight: "bold",
                      }}
                      bodyStyle={{ textAlign: "left" }}
                    />
                    <Column
                      field="value"
                      style={{ width: "50%", textAlign: "left" }}
                      bodyStyle={{ textAlign: "left" }}
                    />
                  </DataTable>
                </>
              </div>
              <div className="field col-12 md:col-3 mt-3">
                <Button
                  rounded
                  text
                  raised
                  style={{ backgroundColor: "#fff", width: "150px" }}
                  label="Regresar"
                  icon="pi pi-arrow-left"
                  className="p-button-danger"
                  onClick={() => {
                    navigate("/status");
                  }}
                />
              </div>
              {userInfo.Roles !== undefined &&
                userInfo.Roles.includes("status.edit") && (
                  <div className="field col-12 md:col-3 mt-3">
                    <Button
                      rounded
                      text
                      raised
                      style={{
                        backgroundColor: "#fff",
                        width: "150px",
                        marginTop: "1%",
                      }}
                      label="Editar"
                      icon="pi pi-file-edit"
                      className="p-button-primary"
                      onClick={() => {
                        navigate(`/status/edit/${status.id}`);
                      }}
                    />
                  </div>
                )}
              {activeSuspend}
            </div>
          </Card>
        )}
      </div>
    </>
  );
};
export default StatusDetail;
